const logoutAction = () => {
  return {
    type: 'LOGOUT_SUCCESS'
  }
}

export default logoutAction
